'use strict';

import {convertDataVToVue} from '../apply_vue_data_directives.js';
import {Infoblock} from './infoblock.js';

export class InfoblockPhone extends Infoblock {
	constructor(component_id) {
		super(component_id);
		this.data  = yalwa.v.components[this.id].data;
		this.vue_data_vars = {
			value : this.data.value,
			country_cc : yalwa.v.components.infoblock_phone.data.country_cc,
			profileEditPhoneNumber : '',
			errorText : ''
		};
		this.vue_method_vars = {
			saveIconBoxData() {
				this.is_saving = true;
				//Post Ajax Only
				yalwa.accounts.phone_submit_request(this.profileEditPhoneCC, this.profileEditPhoneNumber).done((response) => {
					if (response.success) {
						this.errorText = '';
						this.value.push({country_code : this.selectedDial, text : this.profileEditPhoneNumber, number : response.item.number});
						this.profileEditPhoneNumber = '';
					} else if (response.error) {
						this.errorText = response.error;
						this.profileEditPhoneNumber = '';
					}
					this.is_saving = false;
				}).fail(() => {
					this.is_saving = false;
				});
			},
			close() {
				this.closeDialog();
				this.newValue = '';
			},
			deleteRecord(id, number) {
				//Remove
				jQuery.post(
					'/api/ajax/phone_remove',
					{
						number: number
					},
					(response) => {
						if (response.success) {
							this.value.splice(id, 1);
						} else if (response.error) {
						
						}
					},
					'json'
				);
			}
		};
	}
	
	setup_vars(Vue) {
		this.init_select();
		const profileEditPhoneCC = Vue.ref(null)
		let country_cc = yalwa.v.components.infoblock_phone.data.country_cc;
		
		const defaultEntry = Object.values(country_cc)
			.find(item => item.selected)
		
		if (defaultEntry) {
			profileEditPhoneCC.value = defaultEntry.value
		}
		
		const selectedDial = Vue.computed(() => {
			const entry = Object.values(country_cc)
				.find(item => item.value === profileEditPhoneCC.value)
			
			return entry ? entry.dial : ''
		})
		
		return {
			profileEditPhoneCC,
			selectedDial
		}
	}
	
	init_select() {
		jQuery('.js-profile_edit_phone_cc').on('change', (e) => {
			let $this = jQuery(e.currentTarget);
			let $selected = jQuery(this).find('option:selected');
			let short_code = $selected.data('short');
			jQuery($this).parent().find('.js-profile_phone_selected_value_cc').text(short_code);
		});
	}
	

}